import React from "react";
import {
  WhySection,
  WhyCard,
} from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import Image from "next/image";

const WhyCardComponent = ({ blok }: { blok: WhyCard & SbBlokData }) => {
  return (
    <div className="col-md-12 col-lg-6" {...storyblokEditable(blok)}>
      <div className="usp card h-100 card-lighter p-4">
        {blok.icon && (
          <Image
            height="100"
            width="100"
            alt={blok.icon.alt || ""}
            title={blok.icon.alt || ""}
            className="mx-auto"
            src={blok.icon.filename || ""}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            loading="lazy"
            quality={75}
          />
        )}
        {blok.title && <h3 className="text-reset mb-3">{blok.title}</h3>}
        {blok.description && (
          <p className="mb-0 text-dark">{blok.description}</p>
        )}
        {blok.cta_button && blok.cta_button_link && (
          <Link
            href={blok.cta_button_link.url || ""}
            className="btn btn-primary mt-3"
          >
            {blok.cta_button}
          </Link>
        )}
      </div>
    </div>
  );
};

const WhySectionComponent = ({ blok }: { blok: WhySection & SbBlokData }) => {
  if (blok.type === "white_icon") {
    return (
      <div {...storyblokEditable(blok)} className="accent-section">
        <div className="container">
          <div className="padding-medium">
            {blok.title && (
              <div className="full-width margin-bottom-medium text-center">
                <h2>{blok.title}</h2>
              </div>
            )}

            <div className="sales-points">
              {blok.cards?.map((card) => (
                <div key={card._uid} className="sales-point one-quarter">
                  {card.icon?.filename && (
                    <Image
                      src={card.icon.filename}
                      alt={card.title || ""}
                      title={card.title || ""}
                      width={90}
                      height={90}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      loading="lazy"
                      quality={75}
                    />
                  )}
                  {card.title && <h3>{card.title}</h3>}
                  {card.description && <p>{card.description}</p>}
                  {card.cta_button && card.cta_button_link && (
                    <Link
                      href={card.cta_button_link.url || "#"}
                      className="button button-secondary"
                    >
                      {card.cta_button}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <section className="bg-primary py-4 py-md-5" {...storyblokEditable(blok)}>
      <div className="container my-2 my-md-3">
        {blok.title && (
          <h2 className="text-white text-center mb-4 pb-md-2 mb-md-5 pb-md-3">
            {blok.title}
          </h2>
        )}
        <div className="row justify-content-center gy-3 gx-md-3 gy-xl-0">
          {blok.cards?.map((card) => <WhyCardComponent key={card._uid} blok={card as WhyCard & SbBlokData} />)}
        </div>
      </div>
    </section>
  );
};

export default WhySectionComponent;
